import { useGameQuery } from '../../hooks/convex/useGameState'
import { useGameContext } from './GameContext'

export const useGameState = () => {
  const { gameId, userId } = useGameContext()
  return useGameQuery(gameId, userId)
}
